import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';
import { E2ERunSummary } from '../../models/E2ERun';

export class ListE2ERunsPayload {
  constructor(public environment = '', public conclusion = '', public cursor = '') {}
}
async function listE2ERuns(
  payload: ListE2ERunsPayload
): Promise<{ runs: E2ERunSummary[]; nextCursor: string | null }> {
  try {
    const query = new URLSearchParams({ limit: '20' });
    for (const key of ['environment', 'conclusion', 'cursor'] as const)
      if (payload[key]) query.set(key, payload[key]);
    const response = await HttpClient.get(`/backoffice/e2e-results?${query}`);
    return response.data;
  } catch (error) {
    throw new ListE2ERunsFailure(error instanceof Error ? error.message : 'Chargement impossible');
  }
}
class ListE2ERunsFailure extends Failure {
  constructor(message: string) {
    super(message, 'e2e-list-failed');
  }
}
export default listE2ERuns;
